<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="专家照片" prop="expert_photo">
              <img :src="infoData.expert_photo" style="width: 50px;height: 50px;" alt="专家照片">
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家名称" prop="expert_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.expert_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家类型" prop="type_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.type_msg"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="手机号/账号" prop="phone">
              <Input disabled="disabled" class="perW30" v-model="infoData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家职位" prop="expert_job">
              <Input disabled="disabled" class="perW60" v-model="infoData.expert_job"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="擅长领域" prop="domain">
              <Input disabled="disabled" class="perW60" v-model="infoData.domain"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="专家简介" prop="expert_profile">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" disabled="disabled" class="perW60"
                     v-model="infoData.expert_profile"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="详细介绍" prop="detail">
              <div style="border: 1px solid #e9e9e9;border-radius: 10px;padding: 10px;">
                <div v-html="infoData.detail"></div>
              </div>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {expertInfoApi} from '@/api/expert/expert'

export default {
  name: 'expertInfo',
  data() {
    return {
      infoData: {
        expert_id: 0,
        expert_photo: '',
        expert_name: '',
        type_msg: '',
        phone: '',
        expert_job: '',
        domain: '',
        expert_profile: '',
        detail: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadFormData(id) {
      expertInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
